// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "span[data-v-3ccfce41]{color:#1071c1}.imagem[data-v-3ccfce41]{width:350px}@media (min-width:768px){.imagem[data-v-3ccfce41]{padding-top:60px}}@media (min-width:1024px){.imagem[data-v-3ccfce41]{padding-top:10px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
